import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { useInView } from '@/hooks/useInView';

export default function FeaturedCategories() {
  const { ref, isInView } = useInView(0.05);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900">
            探索浪漫分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            从约会灵感、蜜月旅行到美食探店，找到属于你们的浪漫方式
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`group relative overflow-hidden rounded-lg h-56 md:h-64 cursor-pointer transition-all duration-700 ${
                isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="absolute inset-0">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="relative z-10 h-full flex flex-col justify-end p-5 md:p-6">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-semibold text-white">{cat.name}</h3>
                </div>
                <p className="text-white/70 text-xs md:text-sm mb-2 line-clamp-2">{cat.description}</p>
                <span className="text-white/50 text-xs">{cat.articleCount} 篇攻略</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}